import type * as React from 'react';
import { put } from '@Domain/Api';
import type { IdentityProviderPayload } from '@Application/Security/Sso/Actions/identityProviderFetched';
import identityProviderSaved, {
	type IdentityProviderSavedAction,
} from '@Application/Security/Sso/Actions/identityProviderSaved';
import identityProviderSaveFailed, {
	type IdentityProviderSaveFailedAction,
} from '@Application/Security/Sso/Actions/identityProviderSaveFailed';
import type SaveIdentityProvider from '@Application/Security/Sso/Commands/SaveIdentityProvider';
import extractMessages from '@Infra/FetchLib/ApiError/extractMessages';
import parameters from '../../../parameters';

type Actions = IdentityProviderSavedAction | IdentityProviderSaveFailedAction;

export default (command: SaveIdentityProvider) => {
	return async (dispatch: React.Dispatch<Actions>): Promise<Actions> => {
		try {
			const payload = await put<IdentityProviderPayload>(
				`${parameters.api.host}/api/accounts/${command.accountId}/identity-provider`,
				command.toJSON(),
			);

			const action = identityProviderSaved(payload, command.accountId);
			dispatch(action);
			return action;
		} catch (error) {
			const action = identityProviderSaveFailed(extractMessages(error));
			dispatch(action);
			return Promise.reject(action);
		}
	};
};
